import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useWishlist } from "../context/WishlistContext";
import ItemCard from "../components/ItemCard";
import OrderTimeline from "../components/OrderTimeline";

export default function Account() {
  const { user } = useAuth();
  const wl = useWishlist();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("orders");

  useEffect(() => {
    api.get("/orders/me").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-10" data-testid="account-page">
      <span className="tag-sticker bg-cyan text-xl rotate-tilt-l inline-block mb-2">your stash</span>
      <h1 className="font-display text-5xl uppercase">Hey {user?.name.split(" ")[0]}</h1>
      <p className="mt-2 opacity-70">{user?.email}</p>

      <div className="flex gap-2 mt-6">
        <button onClick={() => setTab("orders")} className={`brut-btn px-4 py-2 ${tab === "orders" ? "bg-yellow" : "bg-white"}`} data-testid="tab-orders">Purchases ({orders.length})</button>
        <button onClick={() => setTab("wishlist")} className={`brut-btn px-4 py-2 ${tab === "wishlist" ? "bg-pink text-white" : "bg-white"}`} data-testid="tab-wishlist">Wishlist ({wl.items.length})</button>
      </div>

      {tab === "orders" && (
        loading ? (
          <div className="brut p-8 mt-4 font-display text-2xl uppercase">Loading…</div>
        ) : orders.length === 0 ? (
          <div className="brut p-8 mt-4 text-center" data-testid="no-orders">
            <p className="font-display text-2xl uppercase">No orders yet.</p>
            <Link to="/shop" className="brut-btn bg-orange text-white px-6 py-3 mt-4 inline-block">Find your first fit</Link>
          </div>
        ) : (
          <div className="mt-4 flex flex-col gap-4">
            {orders.map((o) => (
              <div key={o.id} className="brut p-5" data-testid={`order-${o.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="font-display text-xl uppercase">Order · ${Number(o.amount).toFixed(2)}</div>
                  <div className="flex gap-2 items-center">
                    <span className="tag-sticker bg-green text-lg">{o.status}</span>
                    {o.shipped && o.tracking_url && <a href={o.tracking_url} target="_blank" rel="noreferrer" className="brut-btn bg-cyan px-3 py-1 text-sm">Track</a>}
                  </div>
                </div>
                <div className="text-sm opacity-70 mt-1">{new Date(o.created_at).toLocaleString()}</div>
                {o.tracking_number && <div className="text-sm mt-1">Tracking: <strong>{o.tracking_number}</strong></div>}
                <OrderTimeline order={o} />
                <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {o.items.map((it) => (
                    <div key={it.id} className="brut-sm p-2 bg-white">
                      <div className="aspect-square overflow-hidden border-2 border-[#1A1A1A]">
                        {it.images?.[0] ? <img src={fileUrl(it.images[0])} className="w-full h-full object-cover" alt="" /> : <div className="w-full h-full bg-[#f3efe6]" />}
                      </div>
                      <div className="font-bold text-sm mt-2 truncate">{it.title}</div>
                      <div className="text-xs">${Number(it.price).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )
      )}

      {tab === "wishlist" && (
        wl.items.length === 0 ? (
          <div className="brut p-8 mt-4 text-center" data-testid="no-wishlist">
            <p className="font-display text-2xl uppercase">No favorites yet.</p>
            <p className="mt-1">Tap the heart on any item to save it for later.</p>
            <Link to="/shop" className="brut-btn bg-pink text-white px-6 py-3 mt-4 inline-block">Browse the rack</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 mt-6" data-testid="wishlist-grid">
            {wl.items.map((it, i) => <ItemCard key={it.id} item={it} idx={i} />)}
          </div>
        )
      )}
    </div>
  );
}
